import React, { useCallback } from "react";
import { Icon, Button } from "nectar-ui";
import useThrottle from "@hooks/useThrottle";
import { RefreshButtonContainer } from "./styles";
import { formatHourAndMinutes } from "@utils/helpers/dateHelper";

type ChartRefetchButtonProps = {
  refetchFunction: () => void;
  updatedAt: Date | number;
};

const ChartRefetchButton: React.FC<ChartRefetchButtonProps> = ({ refetchFunction, updatedAt }) => {
  const handleClick = useCallback(() => {
    refetchFunction();
  }, [refetchFunction]);

  const [throttledFunction, isThrottled] = useThrottle(handleClick);

  return (
    <RefreshButtonContainer>
      <Button disabled={isThrottled} onClick={throttledFunction} outline>
        <Icon icon="fa fa-refresh" style={{ marginRight: "4px" }} />
        <span className="prefix">Atualizado às&nbsp;</span>
        <span className="time">{formatHourAndMinutes(updatedAt)}</span>
      </Button>
    </RefreshButtonContainer>
  );
};

export default ChartRefetchButton;
